import { render } from "./PicnicPackageInclude.vue?vue&type=template&id=45e0e082&scoped=true"
import script from "./PicnicPackageInclude.vue?vue&type=script&lang=js"
export * from "./PicnicPackageInclude.vue?vue&type=script&lang=js"

import "./PicnicPackageInclude.vue?vue&type=style&index=0&id=45e0e082&scoped=true&lang=css"

import exportComponent from "E:\\sanket\\rio\\rio_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e0e082"]])

export default __exports__